import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ActionSheetPopoverComponent } from './common/action-sheet-popover/action-sheet-popover.component';
import { FormControlValidationLabelComponent } from './common/form-control-validation-label/form-control-validation-label.component';
import { LedgerSelectPopoverComponent } from './common/ledger-select-popover/ledger-select-popover.component';
import { ItemDetailsComponent } from './stock/item-details/item-details.component';
import { TranslateComponent } from './translate/translate.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule
    ],
    declarations: [
        ActionSheetPopoverComponent,
        LedgerSelectPopoverComponent,
        FormControlValidationLabelComponent,
        TranslateComponent,
    ],
    entryComponents: [
        ActionSheetPopoverComponent,
        LedgerSelectPopoverComponent,
        FormControlValidationLabelComponent,
        TranslateComponent,
    ],
    exports: [
        ActionSheetPopoverComponent,
        LedgerSelectPopoverComponent,
        FormControlValidationLabelComponent,
        TranslateComponent,
    ]
})

export class SharedModule { }